export default "__VITE_ASSET__DItyjC5s__"